let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hhp6l")).then(() => parcelRequire('9SSs2'));